import React from 'react';
import MeetTheTeam from './assets/MeetTheTeam.png';
import FounderApex from './assets/founder.png';

import A from './assets/ARTIST.png';

import T from './assets/T.png';

import Footer from '../Footer'



import './Founder.css'; // Import the CSS file

function Founder() {
  return (
    <div className="container ">
      <br/>
      <div className='center_everything'>     <img
        src={MeetTheTeam}
        alt="Meet The Team"
        className="responsive-img"
        draggable="false" // <-- This disables dragging
      /></div>
 
      <br />
      <h2 className='Comic_founder'>FOUNDER</h2><br/>
      <div className='center_everything'><img
        src={FounderApex}
        alt="Meet The Team"
        className="responsive-img-founder"
        draggable="false" // <-- This disables dragging
      /></div>
      
 
    

      <p className='Comic_founderp'>Hodlberto</p>

<br/>


<p className='Comic_founderpu'>
I did what they said “adults” do—got the diploma, deans listed, smiled at graduation, carried myself like I had a startup brewing, but really just binge-watched YouTube. And yeah, I pulled it off… somehow, despite barely making it out of high school. But just when things started feeling stable, in came the non-fungible JPEGs. Next thing I know, it’s 4am in Discords with strangers flooding the chat with Pepe emotes, aping into magic internet money, and degenerately minting my first BAYC (#8995) like I accidentally speedran my way into a digital renaissance. Crypto didn’t enlighten me—it absolutely derailed me in the most beautiful way. There’s just something about Jim Cramer’s financial fever dreams, AI-generated cope threads, and X posts violently oscillating between “we’re so back” and “it’s over” that keeps the dopamine pumping. Enough yapping—let’s bring the funsiez to ApeChain.

</p>
<br/>
<br/>






























      <br /> <br /> 
      <h2 className='Comic_founder'>STORYTELLER</h2><br/>
      <div className='center_everything'><img
        src={T}
        alt="Meet The Team"
        className="responsive-img-founder"
        draggable="false" // <-- This disables dragging
      /></div>
      
 
    

      <p className='Comic_founderp'>Cornelius Higgins</p>

<br/>


<p className='Comic_founderpu'>
Walking by faith led me to Boredom Bay—where I turn half-baked thoughts, cartoon reruns, and a little conviction into stories that actually hit. Storyteller first. Builder second. Ape forever.


</p>
<br/>
<br/>

<p className='Comic_founderpu'>
Here to mix memes with meaning, and remind you that purpose doesn’t have to be boring.


</p>




































      <br /> <br /> <br /> <br />
      <h2 className='Comic_founder'>ARTIST</h2><br/>
      <div className='center_everything'><img
        src={A}
        alt="Meet The Team"
        className="responsive-img-founder"
        draggable="false" // <-- This disables dragging
      /></div>
      
 
    

      <p className='Comic_founderp'>Degen Vinci</p>

<br/>


<p className='Comic_founderpu'>
All I needed was a warm burrito, a verse from Proverbs, and a half-charged drawing pad to bring Hodlberto’s unhinged (but kinda genius) ape visions to life. Glad to be part of something that feels more like Saturday morning cartoons than corporate spreadsheets—but still hits different on a blockchain where fun got rugged years ago.



</p>
<br/>
<br/>
<br/>
<br/>
<br/>
<br/>






<Footer/>





























    </div>
  );
}

export default Founder;
